import React, {useEffect, useState} from "react";
import {connect, useSelector, useDispatch} from "react-redux";
import Modal from "../common/Modal/Modal";
import {getPeopleByCompany} from "../../actions/people";
import {useSubmitGuard} from "../common/Helpers";

export function AddViewerModal(props) {

const dispatch = useDispatch();
const peopleInCompany = useSelector(state => state.people.peopleInCompany);
const [email, setEmail] = useState("");
const {isSubmitting, guardedSubmit} = useSubmitGuard();

useEffect(() => {
    dispatch(getPeopleByCompany());
}, []);

const excludedEmails = [props.ownerEmail, ...props.existingViewerEmails];
const candidates = peopleInCompany.filter(person => person && !excludedEmails.includes(person.email));

const handleSubmit = guardedSubmit((e) => {
    e.preventDefault();
    email && props.onSubmit(email);
});

    return (
        <Modal blurBack={true} hasCloseButton={true} handleClose={(e) => props.handleClose(e)} >
            <h2 className="title2 heavy gap-below-s">Add a Viewer</h2>
            <p className="content1 light-black multiline gap-below-m">Choose a colleague to give full visibility into every contract on this project.</p>
            <form className="form" onSubmit={(e) => handleSubmit(e)}>
                <div className="inputs-wrapper gap-below-s">
                    <div className="input-basic">
                        <select
                            name="viewer_email"
                            id="viewer_email"
                            required
                            style={email ? { color: "#3C3B41" } : { color: "#919197" }}
                            onChange={(e) => setEmail(e.target.value)}
                            value={email}
                        >
                            <option value="">Select a colleague</option>
                            {candidates.map(person => (
                                <option key={person.user_id} value={person.email}>{person.first_name} {person.last_name} ({person.email})</option>
                            ))}
                        </select>
                        <label htmlFor="viewer_email">Colleague<span> *</span></label>
                    </div>
                </div>
                {candidates.length === 0 &&
                    <p className="content1 light-black gap-below-s">Everyone at your company already has full visibility into this project.</p>
                }
                <div className="flex-row ">
                    <button
                        id="submit_add_viewer"
                        className="iblock btn expand pri gap-right-xs"
                        disabled={!email || isSubmitting}
                        type="submit"
                    >{isSubmitting ? "Please wait..." : "Add Viewer"}</button>
                    <button type="button" disabled={isSubmitting} className="iblock btn expand sec" onClick={(e) => props.handleClose(e)} >Cancel</button>
                </div>
            </form>
        </Modal>
    )
}

const mapStateToProps = () => ({})

export default connect(mapStateToProps)(AddViewerModal);
